// frontend/src/components/admin/PanelLog.jsx
import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://api.lamilara.com/api';

function formatFecha(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('es-VE', {
    day:'2-digit', month:'short', year:'numeric',
    hour:'2-digit', minute:'2-digit'
  });
}

const ACCION_COLOR = {
  LOGIN:          { bg:'#eff6ff', color:'#1d4ed8' },
  CREAR_USUARIO:  { bg:'#f0fdf4', color:'#15803d' },
  PAGO:           { bg:'#fdf4ff', color:'#7e22ce' },
  GASTO:          { bg:'#fff7ed', color:'#c2410c' },
  IMPORTACION:    { bg:'#f0fdf4', color:'#0369a1' },
  DEFAULT:        { bg:'#f8fafc', color:'#475569' },
};

export default function PanelLog({ token }) {
  const [log,     setLog]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    fetch(`${API}/auth/log`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(d => {
        if (d.ok) setLog(d.log || []);
        else setError(d.mensaje);
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div style={{ padding:24 }}>
      <h2 style={{ fontSize:20, fontWeight:700, color:'#1a3a5c', marginBottom:4 }}>
        🕵️ Registro de Actividad
      </h2>
      <p style={{ fontSize:12, color:'#6b7280', marginBottom:20 }}>
        Historial de acciones realizadas en el sistema
      </p>

      {error && (
        <div style={{ padding:12, background:'#fef2f2', color:'#dc2626',
                      borderRadius:8, marginBottom:16, fontSize:13 }}>
          ⚠️ {error}
        </div>
      )}

      <div style={{ background:'#fff', borderRadius:12,
                    boxShadow:'0 1px 4px rgba(0,0,0,.08)', overflowX:'auto' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:600 }}>
          <thead>
            <tr style={{ background:'#f8fafc' }}>
              {['Fecha','Usuario','Acción','Detalle','IP'].map(h => (
                <th key={h} style={{ padding:'10px 12px', textAlign:'left',
                                     fontSize:11, fontWeight:600, color:'#6b7280',
                                     borderBottom:'2px solid #e5e7eb' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ padding:40, textAlign:'center', color:'#9ca3af' }}>
                Cargando…
              </td></tr>
            ) : log.length === 0 ? (
              <tr><td colSpan={5} style={{ padding:40, textAlign:'center', color:'#9ca3af' }}>
                No hay actividad registrada.
              </td></tr>
            ) : log.map(l => {
              const c = ACCION_COLOR[l.accion] || ACCION_COLOR.DEFAULT;
              return (
                <tr key={l.id} style={{ borderBottom:'1px solid #f3f4f6' }}>
                  <td style={td}>{formatFecha(l.creado_en)}</td>
                  <td style={{ ...td, fontWeight:600, color:'#1a3a5c' }}>
                    {l.nombre || l.usuario || '—'}
                  </td>
                  <td style={td}>
                    <span style={{ background:c.bg, color:c.color,
                                   padding:'2px 8px', borderRadius:12,
                                   fontSize:11, fontWeight:600 }}>
                      {l.accion}
                    </span>
                  </td>
                  <td style={{ ...td, color:'#6b7280', fontSize:12 }}>{l.detalle || '—'}</td>
                  <td style={{ ...td, color:'#9ca3af', fontSize:11 }}>{l.ip || '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
const td = { padding:'10px 12px', verticalAlign:'middle', fontSize:13 };
